import moment from 'moment';
import { SORT_DIRECTION, DATE_FORMAT, UI_EVENTS } from 'constants/app.constant';
import { TableFilterRowType } from 'models';
import { querySelectorWrapper } from './method-wrapper.service';
var filterTableRecords = function (records, filters, searchKeyword, searchField, config) {
    var results = records;
    if (searchKeyword) {
        var refinedKeyword_1 = searchKeyword.trim().toLowerCase();
        if (refinedKeyword_1) {
            results = results.filter(function (record) { return record[searchField].toLowerCase().includes(refinedKeyword_1); });
        }
    }
    Object.keys(filters).forEach(function (key) {
        var _a;
        var filterObj = filters[key];
        var hasData = filterObj.hasData, type = filterObj.type;
        if (hasData) {
            switch (type) {
                case TableFilterRowType.RANGE:
                case TableFilterRowType.DECIMAL_RANGE: {
                    if (filterObj.from) {
                        results = results.filter(function (record) { return record[key] >= filterObj.from; });
                    }
                    if (filterObj.to) {
                        results = results.filter(function (record) { return record[key] <= filterObj.to; });
                    }
                    break;
                }
                case TableFilterRowType.CHECKBOX_MENU:
                case TableFilterRowType.MULTI_SELECT: {
                    if (filterObj.checkedKeys.length) {
                        results = results.filter(function (record) { return filterObj.checkedKeys.includes(record[key]); });
                    }
                    break;
                }
                case TableFilterRowType.SLIDE_SWITCH: {
                    if (filterObj.isChecked) {
                        results = results.filter(function (record) { return record[key] === filterObj.isChecked; });
                    }
                    break;
                }
                case TableFilterRowType.DATE_RANGE:
                case TableFilterRowType.MONTH_RANGE: {
                    if (filterObj.from) {
                        results = results.filter(function (record) { return moment(record[key]).isAfter(moment(filterObj.from, DATE_FORMAT).subtract(1, 'day')); });
                    }
                    if (filterObj.to) {
                        var toField_1 = ((_a = config === null || config === void 0 ? void 0 : config.find(function (item) { return item.key === key; })) === null || _a === void 0 ? void 0 : _a.toField) || key;
                        var filterToMoment_1 = moment(filterObj.to, DATE_FORMAT).add(1, 'day');
                        results = results.filter(function (record) {
                            var recordMoment = moment(record[toField_1]);
                            return recordMoment.isValid() && recordMoment.isBefore(filterToMoment_1);
                        });
                    }
                    break;
                }
                case TableFilterRowType.DROPDOWN: {
                    if (filterObj.selectedOptionValue) {
                        results = results.filter(function (record) { return record[key] === filterObj.selectedOptionValue; });
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        }
    });
    return results;
};
// Mirrors what ResponsiveTable's own header click does to trigger a scroll, for callers that need
// to scroll the table into view without going through an actual column sort (e.g. a manual reorder
// that must not touch any column's active-sort state).
var dispatchScrollToTableEvent = function (tableId) {
    var customEventType = UI_EVENTS.scrollToTable;
    if (tableId) {
        customEventType += tableId;
    }
    // To make sure others event done
    setTimeout(function () {
        var evt = new CustomEvent(customEventType);
        window.dispatchEvent(evt);
    }, 0);
};
var triggerSortTableManually = function (sortDirection, columnHeaderSelector, tableId) {
    var activeSortSelector = ".c-responsive-table-cell--sort-active";
    var sortedButtonSelector = '.c-els-table__sortable-button';
    var ascSortIconSelector = '.c-responsive-table-cell--sort-asc';
    var isColumnSorting = querySelectorWrapper("".concat(columnHeaderSelector).concat(activeSortSelector)) !== null;
    var sortedButtonElm = querySelectorWrapper("".concat(columnHeaderSelector, " ").concat(sortedButtonSelector));
    if (!sortedButtonElm) {
        return;
    }
    if (isColumnSorting) {
        var isSortingAsc = querySelectorWrapper("".concat(columnHeaderSelector).concat(activeSortSelector, " ").concat(sortedButtonSelector, " ").concat(ascSortIconSelector)) !== null;
        if (isSortingAsc) {
            if (sortDirection === SORT_DIRECTION.DESC) {
                sortedButtonElm.click();
            }
            else {
                dispatchScrollToTableEvent(tableId);
            }
        }
        else if (sortDirection === SORT_DIRECTION.ASC) {
            sortedButtonElm.click();
        }
        else {
            dispatchScrollToTableEvent(tableId);
        }
    }
    else {
        sortedButtonElm.click(); // The first click will be sort ASC
        if (sortDirection === SORT_DIRECTION.DESC) {
            // To make sure the first click done
            setTimeout(function () {
                sortedButtonElm.click();
            }, 0);
        }
    }
};
var scrollToTable = function (offsetTableTop, behavior) {
    if (behavior === void 0) { behavior = 'smooth'; }
    var pageHeaderSelector = querySelectorWrapper('.c-page-header');
    scrollTo({ left: 0, top: offsetTableTop - pageHeaderSelector.offsetHeight, behavior: behavior });
};
// Maps a ResponsiveTable column position (1-based) to the header/body cell selectors for that column.
// ResponsiveTable renders a sticky first column in its own table, separate from the scrollable columns
// table, so header nth-of-type indexes reset to 1 within each of them.
var getSortingColumnSelector = function (columnIndex) {
    var body = ".c-responsive-table-body-row > .c-responsive-table-body-cell:nth-of-type(".concat(columnIndex, ")");
    var header = columnIndex === 1
        ? '.c-responsive-table-first-col-header .c-els-table__cell--header'
        : ".c-responsive-table-header-inner .c-els-table__cell--header:nth-of-type(".concat(columnIndex - 1, ")");
    return { body: body, header: header };
};
var classActions = {
    ADD: 'ADD',
    REMOVE: 'REMOVE'
};
// flashClass is a parameter (not a fixed constant) since each table defines its own BEM flash class.
var actionFlashPromise = function (flashClass, action) {
    if (action === void 0) { action = classActions.ADD; }
    return function (wrapper) {
        var _a, _b;
        if (action === classActions.ADD) {
            (_a = wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList) === null || _a === void 0 ? void 0 : _a.add(flashClass);
        }
        else {
            (_b = wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList) === null || _b === void 0 ? void 0 : _b.remove(flashClass);
        }
        return Promise.resolve(true);
    };
};
// Resolves once the wrapper's CSS flash animation actually finishes, so callers never need to
// know/duplicate the animation's duration from the table's own scss (single source of truth).
var waitForFlashAnimationEnd = function (wrapper) {
    return new Promise(function (resolve) {
        if (!wrapper) {
            resolve(true);
            return;
        }
        wrapper.addEventListener('animationend', function () {
            resolve(true);
        }, { once: true });
    });
};
export { filterTableRecords, triggerSortTableManually, dispatchScrollToTableEvent, scrollToTable, getSortingColumnSelector, classActions, actionFlashPromise, waitForFlashAnimationEnd };
